(function () { 
  
  'use strict';

  function popup($timeout, TenantListService, $filter, toastr, $rootScope) {
    return {
      restrict: 'EA',
      scope: {
        popupCalibration: '=popupCalibration',
        clearPopup: '&clearPopup',
        deleteDriverConfig: '&deleteDriverConfig'
      },
      templateUrl: 'app/directives/popUpDirective/pop-up.template.html',
      link: function(scope) {

        scope.list = []; // set this with popupCalibration
        scope.popupType = scope.popupCalibration.popupType;
        scope.enableDriverConfigurationSelect = false;
        scope.isConfigurationNameValid = false;
        scope.createConfigIsValid = false;
        scope.copyOfConfigurationName = scope.popupCalibration.name;

        //*****************//
        // INIT 
        // ------------------
        //  Sort valid workstations (support only windows)
        //  Set relevant classes
        //*****************//
        function openPopup() {
          checkForEligibleWorkstations();
          setClasses();
        }
        openPopup();
        
        function checkForEligibleWorkstations() {
          var users = $filter('stringular')($filter('translate')('Users'));
          var user = $filter('stringular')($filter('translate')('USER'));
          var eligbleComputers = [];
          var nonEligbleComputers = [];

          // MARK DISABLED, IF MORE THAN USER IS LOGGED IN AND ADD USERS TO NAME
          for (var i = 0; i < scope.popupCalibration.workstations.length; i++) {
            if (Array.isArray(scope.popupCalibration.workstations[i].info._links['px:user'])) {
              scope.popupCalibration.workstations[i].info.selectDisabled = true;
              scope.popupCalibration.workstations[i].info.dimmed = true;
              scope.popupCalibration.workstations[i].info.name += ' (' + users + ': ' + scope.popupCalibration.workstations[i].info._links['px:user'].length + ')'
            } else {
              scope.popupCalibration.workstations[i].info.name += ' (' + user + ': 1)'
            }
          }

          // SPLIT WORKSTATIONS INTO TWO ARRAYS
          for (var i = 0; i < scope.popupCalibration.workstations.length; i++) { 
            if (scope.popupCalibration.workstations[i].info.selectDisabled) {
              nonEligbleComputers.push(scope.popupCalibration.workstations[i].info)
            } else {
              eligbleComputers.push(scope.popupCalibration.workstations[i].info);
            }
          }
          
          var breaker = {
            name: '--------------------',
            break: true,
            selectDisabled: true,
            id: null
          }
          
          if (eligbleComputers.length  && nonEligbleComputers.length) {
            eligbleComputers.push(breaker);
            scope.list = eligbleComputers.concat(nonEligbleComputers);
          } else if (!eligbleComputers.length && nonEligbleComputers.length) {
            eligbleComputers = setWarning(eligbleComputers);
            eligbleComputers.push(breaker);
            scope.list = eligbleComputers.concat(nonEligbleComputers);
          } else if (eligbleComputers.length && !nonEligbleComputers.length) {
            scope.list = eligbleComputers;
          }
        }

        function setWarning (eligbleComputers) {
          var message = $filter('stringular')($filter('translate')('YouAndOnlyYouMustBeSignedInToTheComputer'));
          if (eligbleComputers.length === 0) {
            var warning = {
              warning: true,
              selectDisabled: true,
              id: null,
              name: message
            }
            eligbleComputers.push(warning);
          }
          return eligbleComputers;
        }
        
        function setClasses() {
          angular.element(".pop-up-container").show();
          angular.element(".pop-up-container").parent().parent().addClass('relative');
          angular.element(".pop-up-container").addClass(scope.popupCalibration.popupType);
          if (scope.list.length <= 0) {
            switch (scope.popupCalibration.popupType) {
              case 'complex-form': 
                scope.popupType = 'popup-warning-complex'
                angular.element(".pop-up-container").removeClass(scope.popupCalibration.popupType);
                angular.element(".pop-up-container").addClass(scope.popupType);
              break;
              case 'select-box':
                scope.popupType = 'popup-warning'
                angular.element(".pop-up-container").removeClass(scope.popupCalibration.popupType);
                angular.element(".pop-up-container").addClass(scope.popupType);
              break
            }
          } 
        }

        //*****************//
        // UI 
        // ------------------
        // Set focus on input (called by ng-init from template)
        //*****************//
        scope.setFocus = function (){
          angular.element('.configuration-name').focus();
          return true;
        }
        
        scope.closePopup = function() {
          scope.enableDriverConfigurationSelect = false;
          angular.element(".pop-up-container").hide();
          angular.element(".pop-up-container").removeClass(scope.popupCalibration.popupType);

          scope.clearPopup();
        }

        scope.changeSelect = function(selectedItem) {
          if (selectedItem) {
            scope.enableDriverConfigurationSelect = true;
            scope.selectedWorkstation = selectedItem;
          }
          evaluateCreateConfigForm();
        }

        scope.evaluateConfigName = function(configName) {
          if (configName.length > 0 && configName !== scope.copyOfConfigurationName) {
            scope.isConfigurationNameValid = true;
          } else {
            scope.isConfigurationNameValid = false;  
          }
          evaluateCreateConfigForm();
        }

        function evaluateCreateConfigForm(){
          if (scope.enableDriverConfigurationSelect && scope.isConfigurationNameValid) {
            scope.createConfigIsValid = true;
          } else {
            scope.createConfigIsValid = false;
          }
        }
        
        //*****************//
        // CRUD (no read in this crud :))
        // ------------------
        // Create (driver config)
        // Update (driver config)
        // update (driver name)
        // Delete (driver config)
        //*****************//

        scope.changeAutoInstallSetting =  function(x) {
          scope.popupCalibration.printQueue.saveChanges(scope.popupCalibration.printQueue).then(function(){
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
        }

        scope.createDriverConfigurations = function(configName) { // TODO remove Object to send
          var objectToSend = {
            name: configName,
            workstation: scope.selectedWorkstation,
            os: scope.popupCalibration.operatingSystem
          }
          TenantListService.currentTenant.manageDriverConfig(objectToSend.name, objectToSend.os, objectToSend.workstation, scope.popupCalibration.printer, scope.popupCalibration.printQueue).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.closePopup();
        }

        scope.updateDriverConfiguration = function() {
          var objectToSend = {
            name: scope.popupCalibration.name,
            workstation: scope.selectedWorkstation,
            os: scope.popupCalibration.operatingSystem,
            id: scope.popupCalibration.driverConfig
          }
          TenantListService.currentTenant.manageDriverConfig(objectToSend.name, objectToSend.os, objectToSend.workstation, scope.popupCalibration.printer, scope.popupCalibration.printQueue, objectToSend.id).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          scope.closePopup();
        }
        
        scope.updateDriverConfigurationName = function(newConfigName) {
          var objectToSend = {
            name: newConfigName,
            id: scope.popupCalibration.driverConfig._links.self.href,
            os: scope.popupCalibration.operatingSystem
          }
          TenantListService.currentTenant.updateDriverConfigName(objectToSend.name, objectToSend.os, objectToSend.id, scope.popupCalibration.printer, scope.popupCalibration.printQueue).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){});
          
          scope.closePopup();
        };

        scope.deleteDriverConfiguration = function () {
          scope.deleteDriverConfig({args: scope.popupCalibration});
          scope.closePopup();
        }

        scope.getClient = function(){
          return $rootScope.clientNameValue;
        }

        scope.getOs = function () {
          return scope.popupCalibration.operatingSystem.value
        }
      }
    };
  }

  popup.$inject = ['$timeout', 'TenantListService', '$filter', 'toastr', '$rootScope'];

  angular
    .module('printix-admin')
    .directive('popup', popup);


})();